import script from "./BatchProcessingErrors.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchProcessingErrors.vue?vue&type=script&setup=true&lang=ts"

import "./BatchProcessingErrors.vue?vue&type=style&index=0&id=3ba08dab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ba08dab"]])

export default __exports__